import getConfig from '../../config';
import { Action } from '../../definitions/types';
import * as Actions from '../actions/actions-consts';
import { Prices } from '../actions/options';

export interface MobileSettings {
  os: string;
  isMobile: boolean;
}

export interface Options {
  lang?: string;
  prices?: Prices;
  mobile?: MobileSettings;
  forceIntoDolphin: boolean;
  claimsVariant?: string;
  loadingCta?: boolean; // TODO clean-up GRW-1410 GRW-1416
  loadingPage?: boolean; // TODO clean-up GRW-1410 GRW-1416
  onestopToSAccepted?: boolean; // TODO clean-up GRW-1410 GRW-1416
  userHasBusiness?: boolean; // TODO clean-up GRW-1410 GRW-1416
}

const { language } = getConfig();

export const getLang = (state: Options): string => {
  if (!state) {
    return null;
  }
  return state.lang;
};

export const isMobile = (state: Options): boolean => {
  if (!state) {
    return false;
  }
  return Boolean(state.mobile && state.mobile.isMobile);
};

const initialState: Options = {
  lang: language,
  prices: null,
  mobile: null,
  claimsVariant: '',
  forceIntoDolphin: false,
  loadingCta: false, // TODO clean-up GRW-1410 GRW-1416,
  loadingPage: false, // TODO clean-up GRW-1410 GRW-1416,
  onestopToSAccepted: false, // TODO clean-up GRW-1410 GRW-1416,
  userHasBusiness: false, // TODO clean-up GRW-1410 GRW-1416,
};

export default function option(state: Options = initialState, action: Action<{}>): Options {
  switch (action.type) {
    case Actions.RETRIEVED_PRICES:
      return Object.assign({}, state, { prices: action.payload });
    case Actions.SET_MOBILE_SETTINGS:
      return Object.assign({}, state, { mobile: action.payload });
    case Actions.INCLUDE_IN_CLAIMS_TEST:
      return Object.assign({}, state, { claimsVariant: action.payload });
    case Actions.FORCE_INTO_DOLPHIN:
      return Object.assign({}, state, { forceIntoDolphin: true });
    case Actions.SET_LOADING_CTA: // TODO clean-up GRW-1410 GRW-1416
      return Object.assign({}, state, { loadingCta: action.payload });
    case Actions.SET_LOADING_PAGE: // TODO clean-up GRW-1410 GRW-1416
      return Object.assign({}, state, { loadingPage: action.payload });
    case Actions.SET_TOS_ACCEPTANCE_STATUS: // TODO clean-up GRW-1410 GRW-1416
      return Object.assign({}, state, { onestopToSAccepted: action.payload });
    case Actions.SET_USER_HAS_BUSINESS:
      return Object.assign({}, state, { userHasBusiness: action.payload });
    default:
      return state;
  }
}
